module.exports = __webpack_public_path__ + "static/banner2-2925b4ca805f45e8b18cdc17ff28fc01.jpeg";